import Spacings from "../../../../../../packages/design-system/src/Spacings";
import Table from "../../../../../../packages/design-system/src/Table";
import Text from "../../../../../../packages/design-system/src/Text";
import * as React from 'react';
export default {
  Spacings,
  Table,
  Text,
  React
};